import _ from 'underscore';

export const isEmptyUrl = suggestion => suggestion && suggestion.emptyURL === true;

export const isInvalidUrl = suggestion => suggestion && suggestion.invalidURL === true;

export const isInProgress = suggestion => suggestion && suggestion.inProgress === true;

export const getAlertString = (suggestion, i18n) => {
  let alertString = '';
  if (suggestion) {
    if (isEmptyUrl(suggestion)) alertString = i18n.getString('ImageExperience_EmptyURL');
    else if (suggestion.invalidURL === true) alertString = i18n.getString('ImageExperience_InvalidURL');
    else if (suggestion.inProgress === true) alertString = i18n.getString('ImageExperience_InProgress');
    else if (suggestion.isTimeout === true) alertString = i18n.getString('ImageExperience_Timeout');
    else if (!suggestion.images || _.isEmpty(suggestion.images)) alertString = i18n.getString('ImageExperience_NoSuggestion');
  } else {
    alertString = i18n.getString('ImageExperience_NoSuggestion');
  }
  return alertString;
};
